<template>
<mu-dialog :open = 'true' dialogClass = 'dialog-class train-plan-wrap' bodyClass="train-plan-body">
  <div style = ' height: 100%;  display: flex; flex-direction: column;'>
    <trainMenu  ref="trainmenu" :trainCategories='trainCategories' :isModal = "isModal" @category-path-updated = 'onTrainCategoryChoose'/>
    <div style = 'padding-left:40px; height: 420px; overflow-y: auto;'>
      <mu-circular-progress v-if="fetchGame" class="demo-circular-progress" style="position:absolute;left:50%;top:50%;" :stroke-width="5" :size="48"></mu-circular-progress>
      <card-list v-if="!fetchGame" :isModal = "isModal" :listItems = 'currentTrainCategory ? sortGame(currentTrainCategory.games) : []' :itemComponent = 'trainCard' @list-item-clicked = 'onTrainClicked'/>
    </div>
    <div style = 'height: 30px;'>
    </div>
  </div>
  <div style="position:absolute; bottom:0; right:0; background-color:#fff; display: flex; flex-direction: row; align-items: center; justify-content: flex-end; padding-bottom: 10px;">
    <mu-raised-button  label  = "取消" style  = "backgroundColor: #ddd;" @click = "cancelhandler"/>
    <div style="width: 40px;"/>
    <mu-raised-button  label='去测评' :disabled="showDoTrain" style="width:120px;border-radius:40px;" @click="submitAction" primary/>
    <div style="width: 40px;"/>
  </div>
</mu-dialog>
</template>
<script>
  import Vue             from 'vue'
  import {removeByValue} from '../../../../assets/js/common.js'
  import bz_utils        from '../../../common/tree/utils'
  import CardList        from '../../../../foundation/ui/controls/card-list';
  import trainMenu       from '../../../common/trainMenu.vue'
  import level           from '../../../common/levels.vue'
  import TrainListItem   from '../../../bz/eval-card';
  var _ = require('lodash');
  export default ({
    // 获取父级数据
    props: {
      //用于显示弹框的title
      title: {
        type: String,
        default: ''
      },
      //已经选择的训练方案
      games: {
          type: Array,
          default: function(){
              return []
          }
      },
      caseId: String,
      //请求的接口
      url: String
    },
    computed: {
      //当前选中的游戏项数
      itemLength: function(){
        return '确认 (' + this.checkItem.length + ')';
      }
    },
    data() {
      return {
        address: GLOBAL.cognition,
        showLoading: false,
        //选中的游戏
        checkItem:[],
        oneGrade: '',
        twoGrade: '',
        trainList: [],
        disabled: true,
        showDialog: false,
        trainCategories: bz_utils.buildEvalCategoryTree(),
        currentTrainCategory: null,
        trains: null,
        trainCard: TrainListItem,
        selectedGames: {},
        isModal:true,
        fetchGame:true,
        count:0,
        isEval:true,
        showDoTrain:true,
        message: {
          initPromise: null,
          caseId: '', //病例id
          scaleId: '',//量表id
          scaleAliasName: '', //量表别名
          isRestart: false, //是否是重新测评
          // 是否开始监听message
          inited: false,
          targetWindow: null,
          modules: []
        },
        thirdpartyurl: g_k_urls.WAB,
      }
    },
    components:{
      trainMenu,
      level,
      'card-list': CardList,
    },
    mounted() {
      // this.fetch();
      // console.log(bz_utils.buildTrainCategoryTree());
      window.addEventListener('message', this.messageHandler);//第三方测评结束
    },
    methods: {
      submitAction:function(){
        var self = this;
        self.scale = self.checkItem;
          var caseParamsId = "";
          if (self.$route.params.id) {
            caseParamsId = self.$route.params.id;
          }else if (self.caseId) {
            caseParamsId = self.caseId;
          }
          console.log(caseParamsId);
          console.log(self.checkItem['ID']);
        if(self.checkItem['id'] != undefined){
          console.log('2.0 ok!!');
          var caseId = caseParamsId;
          var scaleId = self.checkItem['id'];
          var scaleAliasName = self.checkItem['scaleAlias'];
          var isRestart= false;
          self.openThirdparty(caseId, scaleId, scaleAliasName, isRestart);
        }else{
          console.log('1.0 ok!!');
          this.gotoEval1(caseParamsId,this.checkItem['ID']);
        }
      },
      show: function()
      {
        this.trains = null;
        this.selectedGames = {};
        this.showDialog = true;
      },
      close: function(ev)
      {
        this.$emit("closeModal");
      },
      onTrainClicked: function(ev)
      {
        this.trains.forEach(x=>{
          x["selected"] = false;
        });
        console.log(ev);
        this.checkItem = ev.itemData;
        if (this.checkItem.selected){
          this.checkItem.selected = false;
        }else{
          this.checkItem.selected = true;
        }
        this.showDoTrain = false;
      },
      sortGame: function(games){
        //2.0和1.0量表字段大小写不一样y
        var arr = [];
        if(this.count > 0){
          this.trains.forEach((item)=>{
            if(item.id){
              item['ID'] = item.id; 
            }
            games.forEach((game)=>{
              if(game.id){
                game['ID'] = game.id;
              }
              if(game.ID == item.ID){
                arr.push(game);
              }
            })
          })
        }
        return arr;
      },
      openThirdparty: function (caseId, scaleId, scaleAliasName, isRestart) {
        var self = this;
        _.assign(self.message, {
          caseId: caseId,
          scaleId: scaleId,
          scaleAliasName: scaleAliasName,
          isRestart: isRestart
        });
        //        self.message.caseId=caseId;
        //        self.message.scaleId=scaleId;
        //        self.message.scaleAliasName=scaleAliasName;
        //        self.message.isRestart = isRestart;
        //        self.initPromise = isRestart ? Promise.resolve() : self.$http.get('/api/Thirdparty/getModules', { scaleId: scaleId, caseId: caseId });
        self.initPromise = isRestart ? Promise.resolve() : Vue.http({
          method:'GET',
          url:'/api/Thirdparty/getModules',
          params:{ scaleId: scaleId, caseId: caseId }
        });
        //        this.initPromise = self.$http.get('/api/Thirdparty/getModules', { scaleId: scaleId, caseId: caseId });
        // 为解决弹出窗口会被拦截的问题，需要设置为先打开地址然后获取模块
        //        self.message.targetWindow = window.open('http://thirdparty.66nao.com' + '/#!/'
        self.message.targetWindow = window.open(self.thirdpartyurl + '/#!/'
          + scaleAliasName + '?origin=' + location.origin + (isRestart ? '&restart=restart' : ''));
        self.message.inited = true;
        self.initPromise.then(function (result) {
          if (result) {
            self.message.caseId=result.data.data.uid;
            self.message.modules = result.data.data.modules;
            self.message.lastDay = result.data.data.lastDay;
          //console.log(result.data.data.lastDay);
          }
        });
      },
      
      gotoEval1:function(caseId,scaleId){
        var self = this;
        if (this.scale.uri)
        {
          // debugger;
          this.$router.push({ path: "/doc/assessment",query: { caseId: caseId, scaleId:scaleId, template_uri:this.scale.uri}});
          return;
        }
        if(caseId){
          self.$router.push({ path: "/doc/startEval/",query: { caseId: caseId, scaleId:scaleId}});
        }

      },
      onTrainCategoryChoose(categoryPath){
        var self = this;
        let cat = categoryPath.slice(-1)[0];
        let eval2;
        this.currentTrainCategory = cat;
        if (this.trains === null){
          Vue.http({
            method: 'GET',
            url:'/api/Evaluation/getScales',
            params: {}
          })
          .then((res)=>{
            eval2 = res.data.data;
            Vue.http({
              method: 'GET',
              url: '/api/Evaluation/assess_scales',
            }).then(resp=>{
              let flat_games =resp.data.data;
              flat_games = eval2.concat(flat_games);
              flat_games.forEach(x=>{
                x["selected"] = false;
              });
              self.trainCategories.resetGames(flat_games,true);
              self.trains = flat_games;
              self.count ++;
              this.fetchGame = false;
            })
          });
        }
      },
      
      //取消按钮
      cancelhandler(){
        this.close();
      },
      //确认按钮
      confirmHandler(checkItem){
        this.close();
        console.log(Object.values(this.selectedGames));
        this.$emit('submitData', Object.values(this.selectedGames));
        $(".right-content").css("overflow","auto");
      },
      messageHandler: function (data) {
        var self = this;
        // 页面当开第三方测评后才开始监听
        if (self.message.inited) {
          if (data.data.source && data.data.source === 'thirdparty') {
//            console.log(new Date(),'----------->', data);
            switch (data.data.message) {
              // 页面加载完成
              case 'opened':
                console.log('打开：');
                var postData = { source: 'rehab', message: 'start', aliasName: self.message.scaleAliasName };
                if (!self.message.isRestart) {
                  _.assign(postData, { modules: this.message.modules, lastDay: this.message.lastDay });
//                  postData.module = self.message.modules;
//                  postData.lastDay = self.message.lastDay;
                }
                // 数据获取完成后再发送消息
                self.initPromise.then(function () {
                  // 开始测评消息
//                  setTimeout(function(){
//                    self.message.targetWindow.postMessage(postData,'http://kf.ngrehab.66nao.com:90');
//                  },1000);
                  self.message.targetWindow.postMessage(postData,self.thirdpartyurl);
                });
                break;
              // 获取模块具体完成信息
              case 'module:status':
                console.log('状态：');
                var moduleIndex = data.data.moduleIndex;
//                console.log(moduleIndex,self.message.scaleId,self.message.caseId);
//                self.$http.get('/api/Thirdparty/getModuleStatus', {
//                  scaleId: self.message.scaleId,
//                  caseId: self.message.caseId,
//                  moduleIndex: moduleIndex
//                })
                Vue.http({
                  method:'GET',
                  url:'/api/Thirdparty/getModuleStatus',
                  params:{
                    scaleId: self.message.scaleId,
                    caseId: self.message.caseId,
                    moduleIndex: moduleIndex
                  }
                })
                  .then(function (result) {
                    self.message.targetWindow.postMessage({
                      source: 'rehab',
                      message: 'module:status:ok',
                      aliasName: self.message.scaleAliasName,
                      module: result.data
                    }, self.thirdpartyurl);
                  });
                break;
              // 更新模块信息
              case 'module:update':
                console.log('更新：');
//                  console.log('testID');
//                console.log(self.message.scaleId);
                self.$http.post('/api/Thirdparty/updateModule', {
                  scaleId: self.message.scaleId,
                  caseId: self.message.caseId,
                  moduleIndex: data.data.index,
                  time: data.data.time,
                  module: data.data.module
                }, {emulateJSON: true})
                  .then(function (result) {
                    self.message.targetWindow.postMessage({
                      source: 'rehab',
                      message: 'module:update:ok'
                    },self.thirdpartyurl);
                  });
                break;
              // 提交测评，生成报告
              case 'commit':
                console.log('提交：');
//                  console.log(data.data);
                self.$http.post('/api/Thirdparty/commit', {
                  scaleId: self.message.scaleId,
                  caseId: self.message.caseId
                }, {emulateJSON: true})
                  .then(function (result) {
                    self.message.targetWindow.postMessage({ source: 'rehab', message: 'commit:ok' }, self.thirdpartyurl);
                    if (result.data.resultCode === 20000) {
                      console.log('commit is ok!!');
                      self.$parent.showEvaluation=false;//隐藏现场测评浮层
                      if(this.$route.name=="evalRecord"){
                        window.location.reload(true);
                      }else{
                        self.$router.push({ path: '/doc/cases/evalRecord/'+self.message.caseId,query: { reId: result.data.reportId}});
                      }
                    }
                  });
                break;
            }
          }
        }
      },
      
    },
    beforeDestroy(){
      this.inited = false;//第三方测评结束
      window.removeEventListener('message', this.messageHandler);//第三方测评结束
      if(!this.addPlan){
        return;
      }
      this.checkItem.forEach(function(item, index){
        item.checked = false;
      });
    }
  })
</script>
<style lang="stylus">
  @media (min-width:1280px)
    .mu-dialog.dialog-class
      width 1024px 
      max-width 1024px
  
  @media (max-width:1280px)
    .mu-dialog.dialog-class
      width 1024px 
      max-width 1024px
      height 600px
      max-height 600px
  .mu-dialog-actions
    min-height 0 !important
    padding 0px !important
  .modalList-add
    max-height 380px !important
    min-height 380px !important
  .touming
    position relative
  .touming::after
    content ' '
    position absolute
    left 0
    top 0
    display inline-block
    width 140px
    height 140px
    background-color #000
    opacity 0.5

  .hideImg
    display none
  .u-train-doc
    text-align center

  .modal-footer
    button
      border-radius 20px !important
  .train-plan-body
    padding 0 !important
    height 560px !important
  .train-plan-wrap
    position relative !important
    height 640px !important
</style>



// WEBPACK FOOTER //
// evaluationModal.vue?18c41db2